const scope_0 = require('/opt/build/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
const scope_1 = require('/opt/build/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/5ba4a59a4ea69c5258dc399aaf257e92.js').default;
const scope_2 = require('/opt/build/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/869696d3226a431987cd9b31b2459f54.js').default;
const scope_3 = require('/opt/build/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/d5f6b9d1b25733f0a02d85b4bc883343.js').default;
const scope_4 = require('/opt/build/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/f9fdf3b9a25f8e013e0be776e68f38f5.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    